<script>
/**
 * 브랜드 선택화면 컴포넌트(service select screen component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define

export default {
  name: "DownloadAppPage",
  data() {
    return {};
  },

  beforeRouteEnter(to, from, next) {
    if (to.name === "DownloadAppPage" && from.name == null) {
      window.location.href =
        "https://clpintergrateuploadcontents.s3-ap-northeast-1.amazonaws.com/samsung/SamsungSTAR/Update_page/download.html";
    } else {
      next();
    }
  },
};
</script>
